
import { IconAd2,IconUserPlus,IconDashboard ,IconMapPin,IconKey,IconTypography,IconPalette,IconLogout,IconWallet,IconCurrentLocation,IconGenderTransgender} from '@tabler/icons';
// constant
const icons = { IconAd2,IconMapPin,IconUserPlus,IconDashboard ,IconKey,IconTypography,IconPalette,IconLogout,IconWallet,IconCurrentLocation,IconGenderTransgender};

 

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const User = {
  id: 'dashboard',
  title: '',
  type: 'group',
  children: [
  
    {
      id: 'user-dashboard',
      title: 'User Dashboard',
      type: 'item',
      url: '/user/dashboard',
      icon: icons.IconDashboard,
      breadcrumbs: false
    },
  
    {
      id: 'wallet',
      title: 'Wallet',
      type: 'item',
      url: '/user/wallet',
      icon: icons.IconWallet,
      breadcrumbs: false
    },
    {
      id: 'locations',
      title: 'Locations',
      type: 'item',
      url: '/user/locations',
      icon: icons.IconCurrentLocation,
      breadcrumbs: false
    },
    {
      id: 'tariff',
      title: 'Tariff',
      type: 'item',
      url: '/user/tariff',
      icon: icons.IconGenderTransgender,
      breadcrumbs: false
    },
    {
      id: 'util-color2',
      title: 'Logout',
      type: 'item',
      url: '/login',
      icon: icons.IconLogout,
      breadcrumbs: false
    },
    
    // {
    //   id: 'authentication',
    //   title: 'Authentication',
    //   type: 'collapse',
    //   icon: icons.IconKey,

    //   children: [
    //     {
    //       id: 'login3',
    //       title: 'Login',
    //       type: 'item',
    //       url: '/pages/login/login3',
    //       target: true
    //     },
    //     {
    //       id: 'register3',
    //       title: 'Register',
    //       type: 'item',
    //       url: '/pages/register/register3',
    //       target: true
    //     }
    //   ]
    // }
  ]
};
export default User;
